import React from 'react';
import Select, { components } from 'react-select';

export default class DeleteSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.initializeSelected(props.defaultValue || []),
      showPrompt: false,
      itemToRemove: null,
    };
  }

  initializeSelected = (input) => {
    return (input || []).map((item) => ({
      ...item,
      note: item.note || '',
    }));
  };

  confirmRemove = (confirm) => {
    if (confirm && this.state.itemToRemove) {
      const updated = this.state.selected.filter(
        (s) => s.value !== this.state.itemToRemove.value
      );
      this.setState({ selected: updated, showPrompt: false, itemToRemove: null });
      if (this.props.onChange) {
        this.props.onChange(updated);
      }
    } else {
      this.setState({ showPrompt: false, itemToRemove: null });
    }
  };
  // handleChange = (selected, actionMeta) => {
  //   if (actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') {
  //     const confirmDelete = window.confirm('Are you sure you want to remove this item?');
  //     if (!confirmDelete) {
  //       return;
  //     }
  //   }
  //   const updated = (selected || []).map((item) => {
  //     const existing = this.state.selected.find((s) => s.value === item.value);
  //     return { ...item, note: existing?.note || '' };
  //   });
  //   this.setState({ selected: updated });
  //   if (this.props.onChange) {
  //     this.props.onChange(updated);
  //   }
  // };
  handleRemove = (item) => {
    this.setState({ showPrompt: true, itemToRemove: item });
  };
  
  handleChange = (selected, actionMeta) => {
    if (actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') {
      const item = actionMeta.removedValue;
      this.handleRemove(item);
      return;
    }
    const updated = (selected || []).map((item) => {
      const existing = this.state.selected.find((s) => s.value === item.value);
      return { ...item, note: existing?.note || '' };
    });
    
    this.setState({ selected: updated });
      if (this.props.onChange) {
        this.props.onChange(updated);
      }
  };

  renderPrompt() {
    if (!this.state.showPrompt) return null;
    return (
      <div className="prompt">
        <p>Are you sure you want to remove this item?</p>
        <button onClick={() => this.confirmRemove(true)}>Yes</button>
        <button onClick={() => this.confirmRemove(false)}>No</button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Select
          isMulti
          placeholder="Select Provider Subscription"
          value={this.state.selected}
          options={this.props.options || []}
          onChange={this.handleChange}
          backspaceRemovesValue={false} // disables removing values with Backspace
          deleteRemovesValue={false}    // disables removing values with Delete
        />
        {this.renderPrompt()}
      </div>
    );
  }
}

